import React from 'react'
import styled from 'styled-components'

import Card from 'components/Card'

const SIZES = {
  sm: '400px',
  md: '800px',
  lg: '1200px',
}

const Container = styled.div<{ size: 'sm' | 'md' | 'lg' }>`
  margin: 50px auto;
  max-width: ${({ size }) => SIZES[size]};
`

const StyledCard = styled(Card)`
  padding: 10px 32px;
`

const Title = styled.h1`
  line-height: 32px;
  margin: 20px 0;
  text-align: center;
`

export default function CardScreen({
  children,
  title,
  size = 'sm',
}: {
  children: React.ReactNode
  title?: string
  size?: 'sm' | 'md' | 'lg'
}) {
  return (
    <Container size={size}>
      <StyledCard>
        {title && <Title>{title}</Title>}
        {children}
      </StyledCard>
    </Container>
  )
}
